<template>
  <div>
    <div class="row">
      <div class="col-md-6" style="margin-top: 35px;">
        <div class="meet-name">
          <div class="meet-time">{{ room.title }}</div>
        </div>
      </div>
      <div class="col-md-6" style="margin-top: 35px;">
        <div class="meet-hour" align="right">
          <div class="meet-time">{{ dataAtual }}</div>
        </div>
      </div>
    </div>
    <div class="row" align="right" style="margin-top: 100px;">
      <div class="col-md-12">
        <qrcode-vue v-if="room.id" class="code" :value="room.id + ''" size="250" level="L"></qrcode-vue>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";

import QrcodeVue from "qrcode.vue";
export default {
  data() {
    return {
      dataAtual: "",
      room: {
        title: ""
      }
    };
  },
  methods: {
    RetornaDataHoraAtual() {
      const zeroFill = n => {
        return ("0" + n).slice(-2);
      };
      const interval = setInterval(() => {
        const now = new Date();
        const dataHora =
          zeroFill(now.getUTCDate()) +
          "/" +
          zeroFill(now.getMonth() + 1) +
          "/" +
          now.getFullYear() +
          " " +
          zeroFill(now.getHours()) +
          ":" +
          zeroFill(now.getMinutes()) +
          ":" +
          zeroFill(now.getSeconds());

        this.dataAtual = dataHora;
      }, 1000);
    },
    getRooms: function() {
      let self = this;
      let id = self.$route.params.id;
      let api = self.$store.state.api + "room_open/" + id;

      self.$http
        .get(api)
        .then(response => {
          self.room = response.data;

          console.log(self.room);
        })
        .catch(error => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    }
  },
  mounted: function() {
    const self = this;
    self.RetornaDataHoraAtual();
    let id = self.$route.params.id;
    if (id) {
      self.getRooms(id);
    }
  },
  components: {
    vSelect,
    QrcodeVue
  }
};
</script>
<style scoped>
body {
  background-image: url("https://corporate.innovareti.com.br/static/img/bg-2.7822510.jpg") !important;
  color: #fff !important;
  margin: 0px auto !important;
}
.meet-name {
  margin-left: 15px;
  font-size: 36px;
  font-weight: bold;
  border-left: 5px solid #00ee38;
  padding: 13px;
}
.meet-hour {
  margin-left: 15px;
  font-size: 36px;
  font-weight: bold;
  padding: 13px;
}
.meet-time {
  margin-left: 35px;
}
.cont {
  margin-top: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/Rooms/Terminal.vue